import axios from "axios";
import { store } from "../store";


const employeePortalRequest = axios.create({
    baseURL: process.env.REACT_APP_EMAILS_API,
	headers: {
		'x-api-key': process.env.REACT_APP_EMAILS_API_KEY,
		moduleId: process.env.REACT_APP_MODULE_ID,
		env: process.env.REACT_APP_ENV,
	}
})


export const getRejectionTrackers = async (paginationToken?: string, email?: string) => {
    const companySelected = store.getState().auth.companyselected;
    const sessionData = store.getState().auth.sessionData;
    const userEmail = sessionData?.UserName;
    const userDomain = userEmail?.split('@')[1]?.toLowerCase();
    const showManagement = userDomain === 's10peru.com';
    const ruc = companySelected?.RUC;
    
    const result = await employeePortalRequest.get(
        `/rejected-email-logs/${showManagement ? 'GENERAL': ruc}`,
        {
            params: {
                paginationToken,
                email
            }
        }
    )
        .then(({ data }: any) => data)
        .catch(e => e.response);
    
    return result;
};

export const resetRejectionTracker = async (email: string, blockEmail?: boolean) => {
    const companySelected = store.getState().auth.companyselected;
    const sessionData = store.getState().auth.sessionData;
    const userEmail = sessionData?.UserName;
    const userDomain = userEmail?.split('@')[1]?.toLowerCase();
    const showManagement = userDomain === 's10peru.com';
    const ruc = companySelected?.RUC;

    const result = await employeePortalRequest.put(
        `/rejected-email-logs`,
        { 
            email, 
            ruc: showManagement ? 'GENERAL': ruc,
            blockEmail,
        },
    )
        .then(({ data }: any) => data)
        .catch(e => e.response?.data);
    
    return result;
};

export const getDomainMappings = async (domain?: string) => {
    const result = await employeePortalRequest.get(`/email-mapping`, {
        params: domain ? { domain } : {}
    })
        .then(({ data }: any) => data)
        .catch(e => e.response?.data);
    return result;
};

export const getDomainMappingsByRuc = async () => {
    const companySelected = store.getState().auth.companyselected;
    const ruc = companySelected?.RUC;
    const result = await employeePortalRequest.get(`/email-mapping`, {
        params: { ruc },
    })
        .then(({ data }: any) => data)
        .catch(e => e.response?.data);
    return result;
};

export const upsertDomainMapping = async (payload: any) => {
    const result = await employeePortalRequest.put(`/email-mapping`, payload)
        .then(({ data }: any) => data)
        .catch(e => e.response?.data);
    return result;
};

